import {createGlobalStyle} from 'styled-components';

import {media} from 'web-app/styleguide/utils';

export const CLASSNAME_PREFIX = 'TABLE_STYLE_';
export default createGlobalStyle`
    .${CLASSNAME_PREFIX}nowrap {
        white-space: nowrap;
    }

    .${CLASSNAME_PREFIX}table {
        width: 100%;
        margin-bottom: 0;

        + .${CLASSNAME_PREFIX}table {
            margin-top: 1rem;
        }

        &.${CLASSNAME_PREFIX}simple {
            .${CLASSNAME_PREFIX}tbody {
                border: none;
                background: transparent;
            }
            .${CLASSNAME_PREFIX}tr {
                background: transparent;
                height: auto;
            }
        }

        &.${CLASSNAME_PREFIX}plain {
            .${CLASSNAME_PREFIX}tbody,
            .${CLASSNAME_PREFIX}tr,
            .${CLASSNAME_PREFIX}td,
            .${CLASSNAME_PREFIX}header {
                border: none;
                background: transparent;
            }

            .${CLASSNAME_PREFIX}tr {
                height: auto;
            }

            .${CLASSNAME_PREFIX}td,
            .${CLASSNAME_PREFIX}th {
                padding-top: 0;
                padding-bottom: 0;
                &:first-child {
                    padding-left: 0;
                }
                &:last-child {
                    padding-right: 0;
                }
            }
        }

        &.${CLASSNAME_PREFIX}noOutsideBorder {
            thead,
            tbody,
            .${CLASSNAME_PREFIX}tr {
                border-left: 0;
                border-right: 0;
            }
            thead {
                &,
                .${CLASSNAME_PREFIX}tr:first-child {
                    border-top: 0;
                }
            }
            tbody {
                &,
                .${CLASSNAME_PREFIX}tr:last-child {
                    border-bottom: 0;
                }
            }
        }

        .${CLASSNAME_PREFIX}tbody {
            background: transparent;
            border: 0;
        }
    }

    .${CLASSNAME_PREFIX}header {
        .${CLASSNAME_PREFIX}tr {
            font-weight: 500;
            background: #f9f9f9;
            border: 1px solid rgb(236, 236, 237);
            color: #333;
            text-transform: uppercase;
            font-size: ${props => props.theme.fontConfiguration.sizes.Small};
        font-family: ${props => `Inter, ${props.theme.fontConfiguration.family}`};
            line-height: 1.2rem;
        }

        &.${CLASSNAME_PREFIX}light .${CLASSNAME_PREFIX}tr {
            color: #333;
            background: #fff;
        }
    }

    .${CLASSNAME_PREFIX}tr {
        border: 1px solid rgb(236, 236, 237);
        background: white;
        height: 40px;

        &.${CLASSNAME_PREFIX}emphasis {
            font-weight: 600;
        }

        &.${CLASSNAME_PREFIX}darken {
            background: rgba(0, 0, 0, 0.01);
        }

        &.${CLASSNAME_PREFIX}header {
            background: #f9f9f9;
            font-weight: 500;
            color: #333;
            text-transform: uppercase;
            font-size: ${props => props.theme.fontConfiguration.sizes.Small};
        font-family: ${props => `Inter, ${props.theme.fontConfiguration.family}`};
            line-height: 1.2rem;

            .${CLASSNAME_PREFIX}td {
                white-space: nowrap;
            }
        }

        &.${CLASSNAME_PREFIX}spacer.${CLASSNAME_PREFIX}spacer.${CLASSNAME_PREFIX}spacer {
            background: transparent;
            height: 20px;
            border: 0;
            * {
                border: 0;
            }
        }

        &.${CLASSNAME_PREFIX}sticky {
            td,
            th {
                position: sticky;
                z-index: 1;
                top: breadcrumbHeight;
                background: #fff;
            }
        }

        &.${CLASSNAME_PREFIX}valign {
            &_top .${CLASSNAME_PREFIX}td {
                vertical-align: top;
            }
            &_middle .${CLASSNAME_PREFIX}td {
                vertical-align: middle;
            }
            &_bottom .${CLASSNAME_PREFIX}td {
                vertical-align: bottom;
            }
            &_baseline .${CLASSNAME_PREFIX}td {
                vertical-align: baseline;
            }
        }
    }

    .${CLASSNAME_PREFIX}td,
    .${CLASSNAME_PREFIX}th {
        padding: 12px 8px;

        &:first-of-type {
            padding-left: 16px;
        }

        &.${CLASSNAME_PREFIX}left {
            text-align: left;
        }

        &.${CLASSNAME_PREFIX}right {
            text-align: right;

            &:last-of-type {
                padding-right: 16px;
            }
        }

        &.${CLASSNAME_PREFIX}center {
            text-align: center;
        }

        &.${CLASSNAME_PREFIX}emphasis {
            font-weight: 600;
        }

        &.${CLASSNAME_PREFIX}darken {
            background: rgba(0, 0, 0, 0.01);
        }

        &.${CLASSNAME_PREFIX}noPadding {
            padding: 0;
        }
    }

    .${CLASSNAME_PREFIX}genericTableCell {
        display: flex;
        align-items: center;
    }

    .${CLASSNAME_PREFIX}profileImage {
        display: block;
        width: 32px;
        height: 32px;
        margin-right: 10px;
    }

    .${CLASSNAME_PREFIX}genericTableContent {
        width: 100%;
    }

    .${CLASSNAME_PREFIX}rowCollapseButton {
        flex-shrink: 0;
    }

    .${CLASSNAME_PREFIX}hasVerticalBorders {
        .${CLASSNAME_PREFIX}td,
        .${CLASSNAME_PREFIX}th {
            padding: 8px 10px;
        }
        .${CLASSNAME_PREFIX}td {
            border-left: 1px solid rgb(236, 236, 237);
            border-right: 1px solid rgb(236, 236, 237);

            &:first-child {
                border-left: none;
            }

            &:last-child {
                border-right: none;
            }
        }
    }

    .${CLASSNAME_PREFIX}change {
        display: inline-block;
        white-space: nowrap;
        margin-left: 4px;
        &_indicator {
            margin-right: 4px;
            color: ${props => props.theme.mf.colorPalette.g400};
            display: inline-block;
            font-size: ${props => props.theme.fontConfiguration.sizes.Small};
        font-family: ${props => `Inter, ${props.theme.fontConfiguration.family}`};
            line-height: 1;

            &_negative {
                color: ${props => props.theme.mf.colorPalette.r400};
                .${CLASSNAME_PREFIX}change_indicator_arrow:before {
                    border-color: transparent transparent ${props => props.theme.mf.colorPalette.r400} transparent;
                    transform: translate(-50%, -50%) rotate(180deg);
                }
            }
            &_arrow {
                position: relative;
                display: inline-block;
                height: 10px;
                width: 10px;
                vertical-align: bottom;
                &:before {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 0;
                    height: 0;
                    border-style: solid;
                    border-width: 0 3px 6px 3px;
                    content: '';
                    border-color: transparent transparent ${props => props.theme.mf.colorPalette.g400} transparent;
                }
            }
        }
    }

    ${media.mobile`
        .${CLASSNAME_PREFIX}tr.${CLASSNAME_PREFIX}sticky {
            td,
            th {
                top: 0;
            }
        }
    `}
`;
